var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "banner-config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c(
        "el-form-item",
        {
          staticClass: "style_wrap",
          attrs: {
            prop: "indicator_style",
            rules: [{ required: true, message: "请选择样式" }],
          },
        },
        [
          _c("div", [_vm._v(" 图片轮播样式 ")]),
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(
              _vm.value.config_default_value.indicator_style,
              function (img) {
                return _c("el-image", {
                  key: img.id,
                  class: [
                    "indicator_style",
                    img.id === _vm.value.config.indicator_style && "active",
                  ],
                  attrs: { src: img.imageurl },
                  on: {
                    click: function ($event) {
                      return _vm.changeIndicatorStyle(img.id)
                    },
                  },
                })
              }
            ),
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "margin-bottom": "10px" } },
        [
          _c(
            "el-input",
            {
              attrs: { disabled: "", placeholder: "请输入" },
              model: {
                value: _vm.value.config.width,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "width", $$v)
                },
                expression: "value.config.width",
              },
            },
            [_c("template", { slot: "append" }, [_vm._v("宽")])],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "tips", staticStyle: { color: "#999999" } }, [
        _vm._v(
          " 支持PNG、JPG等格式，展示宽度默认为750，高度根据原图等比例展示 "
        ),
      ]),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "padding_lr",
          attrs: {
            prop: "padding_lr",
            rules: [
              {
                required: true,
                pattern: /^(?:0|[1-9]\d{0,2})$/,
                message: "请输入0-999之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 与页面左右边缘的距离 ")]),
          _c(
            "div",
            {
              staticClass: "tips",
              staticStyle: { color: "#999999", "line-height": "1.2" },
            },
            [
              _vm._v(
                " 当前组件距离屏幕左右边缘的距离，默认为0 可输入0-999正整数 "
              ),
            ]
          ),
          _c("el-input", {
            attrs: { placeholder: "请输入距离", clearable: "" },
            model: {
              value: _vm.value.config.padding_lr,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "padding_lr", _vm._n($$v))
              },
              expression: "value.config.padding_lr",
            },
          }),
        ],
        1
      ),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "upload-item" },
            [
              _c("div", { staticClass: "item-title" }, [
                _c("span", [_vm._v(" 图片" + _vm._s(index + 1) + " ")]),
                _vm.value.config.value.length > 1
                  ? _c("i", {
                      staticClass: "el-icon el-icon-delete",
                      on: {
                        click: function ($event) {
                          return _vm.handleDelUpload(index)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c(
                "div",
                { staticClass: "upload" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "value." + index + ".imageurl",
                        rules: [{ required: true, message: "图片不可为空" }],
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "upload-item-wrap" },
                        [
                          _c("upload-file", {
                            ref: "uploadBanner",
                            refInFor: true,
                            attrs: {
                              "link-url": _vm.linkUrl,
                              tempurl: item.imageurl,
                              uploadInfo: _vm.uploadInfo,
                            },
                            on: {
                              emitUploadFile: function (res) {
                                return _vm.emitUploadFile(res, item)
                              },
                            },
                          }),
                          _c(
                            "div",
                            { staticClass: "btns" },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onUpload(index)
                                    },
                                  },
                                },
                                [_vm._v(" 上传图片 ")]
                              ),
                              _vm.pictureList.length > 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.selectPicture(index)
                                        },
                                      },
                                    },
                                    [_vm._v(" 选择图片 ")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c("config-menu", {
                key: item.uid,
                attrs: {
                  value: item,
                  type: _vm.value.key,
                  index: index,
                  info: _vm.info,
                  menuList: _vm.menuList,
                  childrenMenuList: _vm.childrenMenuList,
                  customerModuleList: _vm.customerModuleList,
                  eBookCategoryList: _vm.eBookCategoryList,
                  aBookCategoryList: _vm.aBookCategoryList,
                  customerPackageList: _vm.customerPackageList,
                  systemMenus: _vm.systemMenus,
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus add-upload",
          attrs: { type: "primary" },
          on: { click: _vm.addUpload },
        },
        [_vm._v(" 新增图片")]
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }